import { render, staticRenderFns } from "./WhatsappPersonal.vue?vue&type=template&id=8297a744&"
import script from "./WhatsappPersonal.vue?vue&type=script&lang=js&"
export * from "./WhatsappPersonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports